import { dataChevronLeftCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronLeftCircleSolid = /*#__PURE__*/createIcon(dataChevronLeftCircleSolid)
export default IconChevronLeftCircleSolid
